import {type SxProps, type Theme, Typography} from "@mui/material";
import {CHAT_GREETINGS, useChatSurface} from "~/pages/chat-agent/hooks/useChatSurface";

/**
 * The empty-chat greeting, worded for the route (see useChatSurface): above the composer on the chat
 * page, centred above it in the Dashboards Atlas panel.
 */
export function ChatGreeting({sx}: {sx?: SxProps<Theme>}) {
    const surface = useChatSurface();
    return (
        <Typography variant={"h5"} sx={[{textAlign: "center", fontWeight: 400}, ...(Array.isArray(sx) ? sx : [sx])]}>
            {CHAT_GREETINGS[surface]}
        </Typography>
    );
}
